import { render, staticRenderFns } from "./EditCourse.vue?vue&type=template&id=5428891c&"
import script from "./EditCourse.vue?vue&type=script&lang=ts&"
export * from "./EditCourse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports